import { render, staticRenderFns } from "./MessageTemplateMenuV2026.vue?vue&type=template&id=ae0029c6&scoped=true"
import script from "./MessageTemplateMenuV2026.vue?vue&type=script&lang=js"
export * from "./MessageTemplateMenuV2026.vue?vue&type=script&lang=js"
import style0 from "./MessageTemplateMenuV2026.vue?vue&type=style&index=0&id=ae0029c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0029c6",
  null
  
)

export default component.exports